import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//import stores
import UserStore from './modules/UserStore'
import AutoShipStore from './modules/AutoShipStore'
import GoodStore from './modules/GoodStore'
import OrderStore from './modules/OrderStore'
import AddressStore from './modules/AddressStore'
import RentedGoodsStore from './modules/RentedGoodsStore'
import InvoiceStore from './modules/InvoiceStore'
import TransactionStore from './modules/TransactionStore'
import PaymentStore from './modules/PaymentStore'
import CartStore from './modules/CartStore'
import CategoryStore from './modules/CategoryStore'
import ReferenceStore from './modules/ReferenceStore'


export default new Vuex.Store({
  modules: {
    userStore: UserStore,
    autoShipStore: AutoShipStore,
    goodStore: GoodStore,
    orderStore: OrderStore,
    addressStore: AddressStore,
    rentedGoodsStore: RentedGoodsStore,
    invoiceStore: InvoiceStore,
    transactionStore: TransactionStore,
    paymentStore:PaymentStore,
    cartStore:CartStore,
    categoryStore: CategoryStore,
    referenceStore: ReferenceStore
  },
  strict: process.env.NODE_ENV !== 'production'
});



// WEBPACK FOOTER //
// ./src/store/index.js